function profile(backendAxiosInstance) {
  async function getProfiles() {
    return backendAxiosInstance.get("/customer/v1/profiles");
  }
  async function getProfile(profileId) {
    return backendAxiosInstance.get(`/customer/v1/profiles/${profileId}`);
  }
  async function createProfile(profileData) {
    return backendAxiosInstance.post(
      "/customer/v1/profiles",
      profileData
    );
  }
  async function deleteProfile(profileId) {
    return backendAxiosInstance.delete(`/customer/v1/profiles/${profileId}`, { data: {} });
  }
  async function patchProfile(profileId, profileData) {
    return backendAxiosInstance.patch(`/customer/v1/profiles/${profileId}`, profileData);
  }
  return {
    getProfiles,
    getProfile,
    createProfile,
    deleteProfile,
    patchProfile
  };
}

export { profile as default };
//# sourceMappingURL=profile.js.map
